export const getCookieConsent = state => state.session.cookies.cookieConsent.allowCookies;



// WEBPACK FOOTER //
// ./src/client/js/store/selectors/cookies/index.js